import { Box, Typography } from '@mui/material';
import { Identifier } from '@okletsplay/core';
import React, { FC } from 'react';
import { PlayerIndexFormat } from 'shared/components/Format/PlayerIndexFormat';
import { useStyles } from './MatchPlayerHeader.styles';
import { MatchPlayerJoinRequestActions } from '../MatchPlayerJoinRequestActions';

interface ComponentProps {
  index: number;
  userId?: Identifier;
  label?: string;
  onAccept?: (id: Identifier) => void;
  onReject?: (id: Identifier) => void;
}

export const MatchPlayerHeader: FC<ComponentProps> = ({
  index,
  userId,
  label,
  onAccept,
  onReject,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>
        <PlayerIndexFormat index={index} label={label} />
      </Typography>
      <MatchPlayerJoinRequestActions userId={userId} onAccept={onAccept} onReject={onReject} />
    </Box>
  );
};
